import { render, staticRenderFns } from "./ModalCrypto.vue?vue&type=template&id=4ae51de8&scoped=true"
import script from "./ModalCrypto.vue?vue&type=script&lang=js"
export * from "./ModalCrypto.vue?vue&type=script&lang=js"
import style0 from "./ModalCrypto.vue?vue&type=style&index=0&id=4ae51de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae51de8",
  null
  
)

export default component.exports